export const baseURL = 'https://tienda.encatalogo.com/';
//export const sistemaURL = 'http://peruanadeinformatica.localhost/'
export const sistemaURL = process.env.REACT_APP_RUTA_SISTEMA
export const imagenesURL = sistemaURL + 'assets/images/imagenesArticulos/'
export default { baseURL, sistemaURL, imagenesURL };
